import { createAction, props } from '@ngrx/store';
import { IOutstandingTodos } from '../models/outstandingTodos.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

export const loadToDos = createAction('[ToDos] Load ToDoss', props<{ request: string }>());

export const loadToDosSuccess = createAction('[ToDos] Load ToDoss Success', props<{ response: IOutstandingTodos }>());

export const loadToDosFailure = createAction('[ToDos] Load ToDoss Failure', props<{ error: IGenericError<ErrorResponse> }>());
